import { render } from "./ImageCropUploader.vue?vue&type=template&id=3c33c206&scoped=true&ts=true"
import script from "./ImageCropUploader.vue?vue&type=script&lang=ts"
export * from "./ImageCropUploader.vue?vue&type=script&lang=ts"

import "./ImageCropUploader.vue?vue&type=style&index=0&id=3c33c206&scoped=true&lang=css"

import exportComponent from "/Users/garyfang/Documents/Projects/vue/boxing_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c33c206"]])

export default __exports__